import en from './i18n/en.json';
import pl from './i18n/pl.json';

export interface CTranslations {
  security: { encrypted: string; public: string };
  select: { empty: string; search: string; cancel: string; confirm: string; selectAll: string; clearAll: string };
  notifications: { close: string };
  navigation: { more: string };
  validation: { maxLength: string };
  datePicker: { cancel: string; confirm: string; today: string; title: string; months: string[] };
  timePicker: { cancel: string; confirm: string; now: string; title: string };
  dateTimePicker: { cancel: string; confirm: string; next: string; back: string; title: string };
}

const translations: Record<string, CTranslations> = { en, pl };

export function getTranslations(locale?: string): CTranslations {
  if (!locale) return translations['en'];
  if (translations[locale]) return translations[locale];

  const base = locale.split(/[-_]/)[0];
  if (translations[base]) return translations[base];

  return translations['en'];
}
